import { ALL_LEGAL_ENTITY_TYPES } from "../../../../types/enums";
import type { GlAccount } from "../types";
import type {LegalEntityType} from "../../../../generated/enums.ts";

function shortCodeForLegalEntityType(legalEntityType: LegalEntityType): string {
    switch (legalEntityType) {
        case 'limited-liability':
            return "BV";
        case 'general-partnership':
            return "VOF";
        case 'sole-proprietorship':
            return "EZ";
        default: {
            const _exhaustive: never = legalEntityType;
            return _exhaustive;
        }
    }
}

export function getApplicableLegalEntityTag(account: GlAccount): string | null {
    const raw = account.applicable_legal_entity_type ?? [];
    const applicable = ALL_LEGAL_ENTITY_TYPES.filter((type) => raw.includes(type));
    if (applicable.length === 0 || applicable.length === ALL_LEGAL_ENTITY_TYPES.length) {
        return null;
    }
    return applicable.map(shortCodeForLegalEntityType).join(" · ");
}
